import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sparepart_view = _resolveComponent("sparepart-view")!
  const _component_portal_page = _resolveComponent("portal-page")!

  return (_openBlock(), _createBlock(_component_portal_page, {
    title: _ctx.pageTitle,
    "show-log-off": true,
    "show-back-button": true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_sparepart_view, { "model-filter": _ctx.allModelsKey }, null, 8, ["model-filter"])
    ]),
    _: 1
  }, 8, ["title"]))
}